<template>
  <div>
    <input
      id="formFile"
      class="form-control"
      type="file"
      accept="image/*"
      :class="{ 'is-invalid': isFileError }"
      @change="onFileChange"
    />
    <small v-if="isFileError" class="text-danger">{{ validationText }}</small>
  </div>
</template>

<script>
export default {
  props: {
    context: {},
    isFileError: {},
    onFileChange: {},
    validationText: {},
  },
}
</script>
